export async function Post(endpoint, language, body) {
    return fetch(endpoint, {
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
            language:language,
            ...body
        }),
    })
}

export async function Get(endpoint) {

    return fetch(endpoint, {
        headers: {
            "Content-Type": "application/json",
        },
        method: "GET",
    })
}
